import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { TranslateModule } from '@ngx-translate/core';
import { EditorModule } from '@tinymce/tinymce-angular';
import { MyCourseCardComponent } from 'app/library/module/components/my-course-card/my-course-card.component';
import { TeamProgramMemberDetailsDialogComponent } from 'app/main/pages/modules/module-form/module-form-participants-tab/team-program-member-details-dialog/team-program-member-details-dialog.component';
import { FuseConfirmDialogModule } from 'app/projects/fuse/src/lib/components/confirm-dialog/confirm-dialog.module';
import { FuseSharedModule } from 'app/projects/fuse/src/lib/shared.module';
import { NgxCleaveDirectiveModule } from 'ngx-cleave-directive';
import { FlatButtonComponent } from './components/buttons/flat-button/flat-button.component';
import { IconButtonComponent } from './components/buttons/icon-button/icon-button.component';
import { MenuItemButtonComponent } from './components/buttons/menu-item-button/menu-item-button.component';
import { WhiteButtonMenuComponent } from './components/buttons/white-button-menu/white-button-menu.component';
import { WhiteButtonComponent } from './components/buttons/white-button/white-button.component';
import { CertificateComponent } from './components/certificate/certificate.component';
import { DialogHeaderComponent } from './components/dialog-header/dialog-header.component';
import { AutocompleteDialogComponent } from './components/dialogs/autocomplete/autocomplete.component';
import { BasicUsersListDialogComponent } from './components/dialogs/basic-users-list/basic-users-list.component';
import { MaxBrainConfirmCheckboxDialogComponent } from './components/dialogs/confirm-checbox/confirm-checkbox.component';
import { MaxBrainConfirmNotifyDialogComponent } from './components/dialogs/confirm-notify/confirm-notify.component';
import { MaxBrainConfirmTextareaDialogComponent } from './components/dialogs/confirm-textarea/confirm-textarea.component';
import { MaxBrainConfirmDialogComponent } from './components/dialogs/confirm/confirm.component';
import { CopyToClipboardDialogComponent } from './components/dialogs/copy-to-clipboard/copy-to-clipboard.component';
import { MaxBrainEditorDialogComponent } from './components/dialogs/editor/editor.component';
import { MoveToDialogComponent } from './components/dialogs/move-to-dialog/move-to-dialog.component';
import { NameToggleDialogComponent } from './components/dialogs/name-toggle/name-toggle.component';
import { NameDialogComponent } from './components/dialogs/name/name.component';
import { RetrySavingDialogComponent } from './components/dialogs/retry-saving/retry-saving-dialog.component';
import { ScheduleSubjectTextDialogComponent } from './components/dialogs/schedule-subject-text/schedule-subject-text.component';
import { SubjectTextDialogComponent } from './components/dialogs/subject-text/subject-text.component';
import { InlineRenameComponent } from './components/inline-rename/inline-rename.component';
import { MSOfficeWebViewerComponent } from './components/ms-office-web-viewer/ms-office-web-viewer.component';
import { PdfWebViewerComponent } from './components/pdf-web-viewer/pdf-web-viewer.component';
import { PerformanceProfilePersonalReviewsListComponent } from './components/preformance-profile-personal-reviews-list/list.component';
import { PerformanceTeamReviewsListComponent } from './components/preformance-team-reviews-list/list.component';
import { ProfilePhotoActionWrapperComponent } from './components/profile-photo-action-wrapper/profile-photo-action-wrapper.component';
import { ProfilePhotoActionWrapperService } from './components/profile-photo-action-wrapper/profile-photo-action-wrapper.service';
import { ProfilePhotoEditorComponent } from './components/profile-photo-editor/profile-photo-editor.component';
import { SearchOutlineComponent } from './components/search-outline/search-outline.component';
import { SmartBannerComponent } from './components/smart-banner/smart-banner.component';
import { TagsCardComponent } from './components/tags-card/tags-card.component';
import { TagsCardService } from './components/tags-card/tags-card.service';
import { TimeInputComponent } from './components/time-input/time-input.component';
import { AutofocusDirective } from './directives/autodocus.directive';
import { MatButtonLoadingDirective } from './directives/mat-button-loading.directive';
import { NoWhitespaceDirective } from './directives/no-white-space-directive.directive';
import { OnlineStateIndicatorDirective } from './directives/online-state-indicator.directive';
import { BreadcrumbMiddleTruncateDirective } from './directives/breadcrumb-middle-truncate.directive';
import { TooltipIfTruncatedDirective } from './directives/tooltip-if-truncated.directive';
import { PersistPageSizeDirective } from './directives/persist-page-size.directive';
import { CalculateDigicompDurationPipe } from './pipes/calculate-digicomp-duration.pipe';
import { CalculateDurationPipe } from './pipes/calculate-duration.pipe';
import { ColorLuminancePipe } from './pipes/color-luminance.pipe';
import { ExcludePipe } from './pipes/exclude.pipe';
import { ExcpectedDurationPipe } from './pipes/expected-duration.pipe';
import { FeatureSwitchPipe } from './pipes/feature-switch.pipe';
import { FilterLanguagesPipe } from './pipes/filter-languages.pipe';
import { FilterTagsPipe } from './pipes/filterTags.pipe';
import { FilterTagsByCategoryPipe } from './pipes/filterTagsByCategory.pipe';
import { FormatTimeSpentPipe } from './pipes/format-time-spent.pipe';
import { GetModuleIconPipe } from './pipes/getModuleIcon.pipe';
import { GetModuleKindLabelPipe } from './pipes/getModuleKindLabel.pipe';
import { GetLaunchButtonLabelPipe } from './pipes/getLaunchButtonLabel.pipe';
import { GetOpenListingButtonLabelPipe } from './pipes/getOpenListingButtonLabel.pipe';
import { GetPostingIconPipe } from './pipes/getPostingIcon.pipe';
import { GetQuestionIconPipe } from './pipes/getQuestionIcon.pipe';
import { GetStatusPipe } from './pipes/getStatus.pipe';
import { GetStatusByValuePipe } from './pipes/getStatusByValue.pipe';
import { GetToDoActionPipe } from './pipes/getToDoAction.pipe';
import { GetUserExtendedAttributeValuePipe } from './pipes/getUserExtendedAttributeValue.pipe';
import { HighlightPipe } from './pipes/highlight.pipe';
import { InitialsPipe } from './pipes/initials.pipe';
import { IsLargeScreenPipe } from './pipes/isLargeScreen.pipe';
import { LanguagePipe } from './pipes/language.pipe';
import { ListingCourseStatusLabelPipe } from './pipes/listing-course-status-label.pipe';
import { MarkdownPipe } from './pipes/markdown.pipe';
import { OrderByPipe } from './pipes/order-by.pipe';
import { OrderByBooleanPipe } from './pipes/orderByBoolean.pipe';
import { SafeHtmlPipe } from './pipes/safeHtml.pipe';
import { SafeUrlPipe } from './pipes/safeUrl.pipe';
import { ScheduleExecDatePipe } from './pipes/schedule-exec-date.pipe';
import { ScheduleIconPipe } from './pipes/schedule-icon.pipe';
import { SearchPipe } from './pipes/search.pipe';
import { ApplyKeywordsToTextService } from './services/apply-keywords-to-text.service';
import { HelperService } from './services/helper';

@NgModule({
    imports: [
        EditorModule,
        FuseSharedModule,
        FuseConfirmDialogModule,
        TranslateModule.forChild({
            extend: true,
            // compiler: {
            //   provide: TranslateCompiler,
            //   useClass: TranslateMessageFormatCompiler,
            // },
        }),
        FormsModule,
        MatButtonModule,
        MatIconModule,
        MatInputModule,
        MatToolbarModule,
        MatCardModule,
        MatCheckboxModule,
        MatChipsModule,
        MatAutocompleteModule,
        MatOptionModule,
        MatTableModule,
        MatMenuModule,
        MatFormFieldModule,
        MatProgressSpinnerModule,
        NgxCleaveDirectiveModule,
        MatRadioModule,
        MatDatepickerModule,
        MatTooltipModule,
        MatListModule,
        MatTreeModule,
        MatSlideToggleModule,
        MatPaginatorModule,
        MatProgressBarModule,
    ],
    declarations: [
        MaxBrainConfirmDialogComponent,
        MaxBrainConfirmCheckboxDialogComponent,
        NameDialogComponent,
        NameToggleDialogComponent,
        MaxBrainEditorDialogComponent,
        MSOfficeWebViewerComponent,
        PdfWebViewerComponent,
        AutocompleteDialogComponent,
        InlineRenameComponent,
        SubjectTextDialogComponent,
        CopyToClipboardDialogComponent,
        ExcludePipe,
        HighlightPipe,
        LanguagePipe,
        ListingCourseStatusLabelPipe,
        FilterTagsByCategoryPipe,
        FilterTagsPipe,
        OrderByPipe,
        SafeHtmlPipe,
        SafeUrlPipe,
        InitialsPipe,
        SearchPipe,
        GetStatusPipe,
        GetStatusByValuePipe,
        CalculateDurationPipe,
        CalculateDigicompDurationPipe,
        ExcpectedDurationPipe,
        OrderByBooleanPipe,
        SmartBannerComponent,
        TimeInputComponent,
        TagsCardComponent,
        MatButtonLoadingDirective,
        AutofocusDirective,
        NoWhitespaceDirective,
        GetModuleIconPipe,
        FeatureSwitchPipe,
        ScheduleSubjectTextDialogComponent,
        ScheduleIconPipe,
        ScheduleExecDatePipe,
        InlineRenameComponent,
        BasicUsersListDialogComponent,
        OnlineStateIndicatorDirective,
        TooltipIfTruncatedDirective,
        PersistPageSizeDirective,
        BreadcrumbMiddleTruncateDirective,
        FilterLanguagesPipe,
        ColorLuminancePipe,
        GetUserExtendedAttributeValuePipe,
        ProfilePhotoEditorComponent,
        ProfilePhotoActionWrapperComponent,
        ColorLuminancePipe,
        MoveToDialogComponent,
        FormatTimeSpentPipe,
        GetQuestionIconPipe,
        MaxBrainConfirmNotifyDialogComponent,
        WhiteButtonComponent,
        DialogHeaderComponent,
        CertificateComponent,
        SearchOutlineComponent,
        FlatButtonComponent,
        IconButtonComponent,
        MenuItemButtonComponent,
        GetToDoActionPipe,
        RetrySavingDialogComponent,
        MaxBrainConfirmTextareaDialogComponent,
        GetModuleKindLabelPipe,
        IsLargeScreenPipe,
        WhiteButtonMenuComponent,
        MarkdownPipe,
        PerformanceProfilePersonalReviewsListComponent,
        PerformanceTeamReviewsListComponent,
        TeamProgramMemberDetailsDialogComponent,
        MyCourseCardComponent,
        GetPostingIconPipe,
        GetOpenListingButtonLabelPipe,
        GetLaunchButtonLabelPipe,
    ],
    providers: [
        ExcludePipe,
        HighlightPipe,
        LanguagePipe,
        ListingCourseStatusLabelPipe,
        FilterTagsByCategoryPipe,
        FilterTagsPipe,
        OrderByPipe,
        SafeHtmlPipe,
        SafeUrlPipe,
        InitialsPipe,
        SearchPipe,
        GetStatusPipe,
        GetStatusByValuePipe,
        CalculateDurationPipe,
        CalculateDigicompDurationPipe,
        ExcpectedDurationPipe,
        OrderByBooleanPipe,
        GetModuleIconPipe,
        GetPostingIconPipe,
        GetOpenListingButtonLabelPipe,
        GetLaunchButtonLabelPipe,
        FeatureSwitchPipe,
        InlineRenameComponent,
        FilterLanguagesPipe,
        GetUserExtendedAttributeValuePipe,
        ProfilePhotoActionWrapperService,
        ColorLuminancePipe,
        HelperService,
        FormatTimeSpentPipe,
        GetQuestionIconPipe,
        GetModuleKindLabelPipe,
        GetToDoActionPipe,
        IsLargeScreenPipe,
        MarkdownPipe,
        TagsCardService,
        ApplyKeywordsToTextService,
    ],
    exports: [
        FuseSharedModule,
        MaxBrainConfirmDialogComponent,
        MaxBrainConfirmCheckboxDialogComponent,
        NameDialogComponent,
        NameToggleDialogComponent,
        MaxBrainEditorDialogComponent,
        MSOfficeWebViewerComponent,
        PdfWebViewerComponent,
        AutocompleteDialogComponent,
        InlineRenameComponent,
        SubjectTextDialogComponent,
        CopyToClipboardDialogComponent,
        ExcludePipe,
        HighlightPipe,
        LanguagePipe,
        ListingCourseStatusLabelPipe,
        FilterTagsByCategoryPipe,
        FilterTagsPipe,
        OrderByPipe,
        SafeHtmlPipe,
        SafeUrlPipe,
        InitialsPipe,
        SearchPipe,
        GetStatusPipe,
        GetStatusByValuePipe,
        CalculateDurationPipe,
        CalculateDigicompDurationPipe,
        ExcpectedDurationPipe,
        OrderByBooleanPipe,
        SmartBannerComponent,
        TimeInputComponent,
        TagsCardComponent,
        MatButtonLoadingDirective,
        AutofocusDirective,
        NoWhitespaceDirective,
        TranslateModule,
        GetModuleIconPipe,
        GetPostingIconPipe,
        GetOpenListingButtonLabelPipe,
        GetLaunchButtonLabelPipe,
        FeatureSwitchPipe,
        ScheduleIconPipe,
        ScheduleExecDatePipe,
        BasicUsersListDialogComponent,
        OnlineStateIndicatorDirective,
        TooltipIfTruncatedDirective,
        PersistPageSizeDirective,
        BreadcrumbMiddleTruncateDirective,
        FilterLanguagesPipe,
        GetUserExtendedAttributeValuePipe,
        ProfilePhotoEditorComponent,
        ProfilePhotoActionWrapperComponent,
        ColorLuminancePipe,
        MoveToDialogComponent,
        FormatTimeSpentPipe,
        GetQuestionIconPipe,
        MaxBrainConfirmNotifyDialogComponent,
        WhiteButtonComponent,
        DialogHeaderComponent,
        CertificateComponent,
        SearchOutlineComponent,
        FlatButtonComponent,
        IconButtonComponent,
        MenuItemButtonComponent,
        GetToDoActionPipe,
        IsLargeScreenPipe,
        RetrySavingDialogComponent,
        GetModuleKindLabelPipe,
        WhiteButtonMenuComponent,
        MarkdownPipe,
        PerformanceProfilePersonalReviewsListComponent,
        PerformanceTeamReviewsListComponent,
        TeamProgramMemberDetailsDialogComponent,
        MyCourseCardComponent,
    ],
})
export class MaxBrainSharedModule {}
